const { SHOW_NOTI_DROPDOWN, ADD_NEW_NOTI, UPDATE_NOTI, GET_NOTI_COUNT,

ADD_NOTI_ERROR, GET_NOTIS, RESET_NOTIS, REMOVE_NOTI_COUNT,
SET_END_OF_NOTIS } = require("../types");


export const showNotiDropdown = () => async dispatch => {  

  dispatch({
    type: SHOW_NOTI_DROPDOWN
  }) 
}

export const addNewNoti = (noti) => dispatch => {
  dispatch({
    type: ADD_NEW_NOTI, 
    payload: noti
  })
}; 


export const updateNoti = (a) => async dispatch => {
  
  dispatch({
    type: UPDATE_NOTI,
    payload: a
  })
};


export const getNotiCount = (payload) => async dispatch => {
  dispatch({
    type: GET_NOTI_COUNT,
    payload
  })
}

export const removeNotiCount = () => {
  return {
    type: REMOVE_NOTI_COUNT
  }
  
}

export const addNotiError = () => dispatch => {
  dispatch({
    type: ADD_NOTI_ERROR
  })
}

export const getNotis = notis => dispatch => {
  dispatch({
    type: GET_NOTIS, 
    payload: notis
  })
}

export const setEndOfNotis = () => dispatch => {
  dispatch({
    type: SET_END_OF_NOTIS
  })
}


export const resetNotis = () => {
  return {
    type: RESET_NOTIS
  };

}

